import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiButton, TuiDialogContext, TuiError, TuiHint, TuiTextfield } from '@taiga-ui/core';
import { TuiInputModule } from '@taiga-ui/legacy';
import { TUI_VALIDATION_ERRORS, TuiFieldErrorPipe } from '@taiga-ui/kit';
import { injectContext } from '@taiga-ui/polymorpheus';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DEFAULT_APP_ICON, DEFAULT_LABELS, FORM_ERRORS, Project } from '@ffx/common';
import { IconDropdownSearchComponent } from '../icon-dropdown-search/icon-dropdown-search.component';
import { uniqueProjectNameValidator } from '../../utils/validators/project-validator';

@Component({
    selector: 'ffx-project-dialog',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TuiButton,
        TuiError,
        TuiFieldErrorPipe,
        TuiHint,
        TuiInputModule,
        TuiTextfield,
        IconDropdownSearchComponent
    ],
    providers: [
        {
            provide: TUI_VALIDATION_ERRORS,
            useValue: {
                required: FORM_ERRORS.REQUIRED,
                duplicateProjectName: FORM_ERRORS.UNIQUE_PROJECT_NAME
            }
        }
    ],
    templateUrl: './project-dialog.component.html',
    styleUrl: './project-dialog.component.scss'
})
export class ProjectDialogComponent {
    private readonly context = injectContext<TuiDialogContext<Project | null>>();
    protected isEdit$ = signal(false);
    private builder = inject(FormBuilder);

    selectedIcon = DEFAULT_APP_ICON;

    protected projectForm = this.builder.nonNullable.group({
        nameControl: ['', [Validators.required, uniqueProjectNameValidator()]],
        iconControl: [this.selectedIcon, []]
    });

    get controls(): any {
        return this.projectForm.controls;
    }

    protected getProject(): Project {
        return {
            id: '',
            name: this.controls.nameControl.value,
            icon: this.controls.iconControl.value,
            owner: '',
            environments: [],
            labels: DEFAULT_LABELS
        };
    }

    protected handleSubmit(): void {
        this.projectForm.markAllAsTouched();
        if (this.projectForm.valid) {
            this.context.completeWith(this.getProject());
        }
    }

    protected dialogDiscard(): void {
        this.context.completeWith(null);
    }

    setIcon(icon: string): void {
        this.selectedIcon = icon;
        this.controls.iconControl.setValue(icon);
    }
}
